<app-licenses-new-license-creation-card [companies]="companies"></app-licenses-new-license-creation-card>
